import React, { useEffect, useState } from "react";
import { Phone, FileText } from "lucide-react";
import { SITE } from "../../lib/siteData";

/**
 * Fixed bottom CTA bar that appears on small screens once the user
 * scrolls past the hero. Two big, thumb-friendly actions: Call + Get A Quote.
 * Hidden on lg+ — desktop already has CTAs everywhere.
 */
export default function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
    // setVisible is stable; onScroll is defined inline — mount-only effect.
  }, []);

  return (
    <div
      className={`lg:hidden fixed inset-x-0 bottom-0 z-40 transition-transform duration-300 ease-out ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      data-testid="sticky-mobile-cta"
      aria-hidden={!visible}
    >
      <div className="mx-3 mb-3 rounded-2xl bg-[#011233] shadow-2xl shadow-[#011233]/40 ring-1 ring-white/10 backdrop-blur-md flex items-stretch overflow-hidden">
        <a
          href={`tel:${SITE.toll_free_tel}`}
          className="flex-1 flex items-center justify-center gap-2 py-3.5 text-white text-sm font-semibold hover:bg-white/5 active:bg-white/10 transition-colors"
          data-testid="mobile-cta-call"
        >
          <Phone size={16} />
          Call
        </a>
        <div className="w-px bg-white/15" aria-hidden="true" />
        <a
          href="#quote"
          className="flex-1 flex items-center justify-center gap-2 py-3.5 bg-white text-[#011233] text-sm font-semibold hover:bg-[#B5BAC2] active:scale-[0.98] transition-all"
          data-testid="mobile-cta-quote"
        >
          <FileText size={16} />
          Get A Quote
        </a>
      </div>
    </div>
  );
}
